"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockQuote = void 0;
const BlockQuote = 'blockquote';
exports.BlockQuote = BlockQuote;
//# sourceMappingURL=blockquote.js.map